<label for="email" class="form-label" translate="field.email"></label>
<div [formGroup]="registerForm" class="input-group has-validation">
  <input type="text" class="form-control" id="email" formControlName="email"
         [ngClass]="{ 'is-invalid': isInvalid() }"
         data-lpignore='true'
  />
  <span class="input-group-text"><i class="fas fa-envelope mx-2"></i></span>
  <div class="invalid-feedback" translate="signIn.registerEmailRequired"></div>
</div>
